<template>
    <div class="download--menu-item" :class="[menuItemClass]">
        <a v-if="depth > 0" class="download--menu-item-link" :style="indent"
            :class="{ 'active': depth == $root.getParents().length && $root.getParents().includes(item.id) }"
            v-on:click="toggleChildren($event); clickHandler(item.id)">
            <i :class="iconClass"></i>
            <span>{{ item.label }}</span>
        </a>
        <template v-for="child in children">
            <download-menu v-show="showChildren" :item="child" :children="child.children"
                :depth="depth + 1" :key="child.id"></download-menu>
        </template>
    </div>
</template>
<script>
export default {
    name: 'DownloadMenu',
    props: {
        item: {
            type: [Array, Object]
        },
        children: {
            type: [Array, Object]
        },
        depth: {
            type: Number
        },
    },
    data: () => ({
        showChildren: false,
        showAllAsActive: false,
        initCategoryId: undefined,
    }),
    computed: {
        indent() {
            if (this.depth > 1) {
                return { paddingLeft: `${(this.depth - 1) * (3.2)}rem` }
            }
            return {}
        },
        iconClass() {
            if (this.depth == 0) return 'icon-ui-folder-open-hover';
            if (this.children && this.showChildren) return 'icon-ui-folder-open-hover';
            if (this.children) return 'icon-ui-folder-closed-default';
            if (this.depth == this.$root.getParents().length 
                && this.$root.getParents().includes(this.item.id)) return 'icon-ui-folder-open-hover';
            return 'icon-ui-folder-closed-default';
        },
        menuItemClass() {
            return ' level_' + this.depth;
        }
    },
    watch: {
        '$root.parents'(value) {
            if (0 < this.depth) {
                if (value.includes(this.item.id)) {
                    return this.showChildren = true;
                }
                this.showChildren = false;
            }
        }
    },
    methods: {
        closeChildren() {
            this.showChildren = false;
        },
        toggleChildren(e) {
            if (0 < this.depth) this.showChildren = !this.showChildren;

            if (this.showChildren) {
                this.$root.$emit('toggle-children', this.item.id);

            } else {
                const parents = this.$root.parents;
                const filteredArr = parents.filter(itemId => itemId !== this.item.id);
                this.$root.setParents(filteredArr);

            }
        },
        clickHandler(id) {
            this.$root.setCategoryId(id);
        },
    },
    mounted() {
        if (this.depth == 0) {
            this.showChildren = true;
            this.showAllAsActive = true;
        }
        if (this.$root.getCategoryId()) {
            const categoryId = parseInt(this.$root.getCategoryId(), 10);
            this.$root.setCategoryId(categoryId);
            this.initCategoryId = categoryId;
            if (this.item.id == this.initCategoryId) {
                this.showChildren = true;
            }
        }

        if (this.$root.parents.includes(this.item.id)) {
            this.showChildren = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.download--menu-item-link {
    span {
        pointer-events: none;
    }
}
</style>